/**
 * Upload Modal
 */
import { merge } from 'lodash';

const initialState = () => ({
    show: false,
    items: [], // filepond internal use
    processingFilesCount: 0,
    options: {
        allowBrowse: true,
        allowDrop: true,
        allowedFileTypes: ['image', 'video', 'document', 'audio', 'other'],
        allowMultiple: true,
        allowPaste: true,
        allowReorder: false,
        allowReplace: false,
        allowRemove: true,
        allowRevert: false,
        allowedFileTypes: null,
        allowImagePreview: true,
        imagePreviewMinHeight: 44,
        imagePreviewMaxHeight: 128,
        labelIdle: '<span>Drop & drop files or <u>browse</u>...</span>',
        onProcessFile: null,
    },
});

// state
export const uploadState = {
    uploadmodal: {
        ...initialState(),
    },
};

// mutations
export const uploadMutations = {
    setMediaUploadModalShow(state, show) {
        state.uploadmodal.show = show;
    },
    setMediaUploadModalItems(state, items) {
        state.uploadmodal.items = items;
    },
    setMediaUploadModalOptions(state, options) {
        state.uploadmodal.options = options;
    },
    setMediaUploadModalProcessingFilesCount(state, processingFilesCount) {
        state.uploadmodal.processingFilesCount = processingFilesCount;
    },
};

// getters
export const uploadGetters = {
    getMediaUploadModalShow(state) {
        return state.uploadmodal.show;
    },
    getMediaUploadModalItems(state) {
        return state.uploadmodal.items;
    },
    getMediaUploadModalOptions(state) {
        return state.uploadmodal.options;
    },
    getMediaUploadModalProcessingFilesCount(state) {
        return state.uploadmodal.processingFilesCount;
    },
};

// actions
export const uploadActions = {
    showMediaUploadModal({ commit, state }, options) {
        commit('setMediaUploadModalOptions', merge({}, state.uploadmodal.options, options));
        commit('setMediaUploadModalShow', true);
    },
    showMediaUpload({ commit, state }, options) {
        if (state.selectmodal.currentView === 'MediaSelect') {
            commit('setMediaSelectModalCurrentView', 'MediaUpload');
        } else {
            commit('setMediaSelectModalCurrentView', 'MediaSelect');
        }
        commit('setMediaUploadModalOptions', merge({}, state.uploadmodal.options, options));
    },
    hideMediaUploadModal({ dispatch }) {
        dispatch('resetMediaUploadModal');
    },
    trackProcessingFiles({ commit, state }, modifier) {
        state.uploadmodal.processingFilesCount += modifier;
        if (state.uploadmodal.processingFilesCount < 0) {
            state.uploadmodal.processingFilesCount = 0;
        }
    },
    resetMediaUploadModal({ state }) {
        state.uploadmodal = Object.assign(
            {},
            {
                ...initialState(),
            }
        );
    },
};
